const DEFAULT_MIME_TYPE = "text/plain";
const DEFAULT_PENDING_TIMEOUT = 350;

const MIME_TYPES = [
  "text/plain",
  "image/jpeg",
  "image/png",
  "text/xml",
  "application/json",
];

export function clipboard(options = {}) {
  const type = MIME_TYPES.includes(options.type)
    ? options.type
    : DEFAULT_MIME_TYPE;
  const pendingTimeout = options.pendingTimeout || DEFAULT_PENDING_TIMEOUT;

  return {
    data: () => ({
      _clipboardText: "",
      clipboardPending: false,
      clipboardPendingTimer: null,
    }),
    methods: {
      async copyToClipboard(value) {
        this.$setClipboardStatus(true);

        if (this.$isClipboardText(value)) {
          return this.$copyTextFallback(value);
        }

        try {
          if (window.ClipboardItem && navigator.clipboard.write) {
            const clipboardItem = new ClipboardItem({ [type]: value });

            await navigator.clipboard.write([clipboardItem]);
            this._clipboardText = "";

            return true;
          }
        } catch (_error) {
          return this.$copyTextFallback(value);
        }

        return this.$copyTextFallback(value);
      },
      async $copyTextFallback(value) {
        if (!this.$isClipboardText(value)) {
          this._clipboardText = "";
          return false;
        }

        const text = String(value);

        try {
          await navigator.clipboard.writeText(text);
          this._clipboardText = text;

          return true;
        } catch (_error) {
          this._clipboardText = "";
          return false;
        }
      },
      $isClipboardText(value) {
        return typeof value === "string" || typeof value === "number";
      },
      $setClipboardStatus(value) {
        this.clipboardPending = value;

        if (this.clipboardPendingTimer) {
          clearTimeout(this.clipboardPendingTimer);
        }

        if (!value) return;

        this.clipboardPendingTimer = setTimeout(() => {
          this.clipboardPending = false;
          this.clipboardPendingTimer = null;
        }, pendingTimeout);
      },
    },
    beforeDestroy() {
      if (this.clipboardPendingTimer) {
        clearTimeout(this.clipboardPendingTimer);
      }
    },
  };
}

export default clipboard;
